/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : DeleteProduct.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : SandeepRaja
 *
 * @Date         : Dec 03, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Feb 17, 2019
 * Description   : ASDS-2055 Update message verbiage.
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
 ******************************************************************************/
import * as React from "react";
import { Modal, Button } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./../ReviewOrder/reviewOrder.css";

interface DeleteMSAProductProps {
    open: boolean;
    onClose?: Function;
    onContinue?: Function;
}
//Delete All the products from cart if soldTo or ShipTo changes

class DeleteMSAProduct extends React.PureComponent<DeleteMSAProductProps> {
  render() {
    return (
      <React.Fragment>
        <Modal
          size="small"
          //closeIcon={true}
          //onClose={() => { this.props.onClose && this.props.onClose() }}
          open={this.props.open}
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
        >
          <Modal.Content>
            <p>
              If you change your Billing Address, All product(s) configured and added to the cart will be deleted.
            </p>
          </Modal.Content>
          <Modal.Footer>
            <div className="display-flex">
              <Button
                type="secondary"
                className="co-secondary-button"
                content="CANCEL"
                data-testid="cancel"
                onClick = {() => { this.props.onClose && this.props.onClose() }}
              />
              <Button
                type="primary"
                className="co-primary-button"
                content="OK"
                data-testid="ok"
                onClick = {() => { this.props.onContinue && this.props.onContinue() }}
              />
            </div>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default DeleteMSAProduct;
